import type { RootState } from "~/app/store";
import { selectProductDescriptor } from "~/domains/product/redux/selectors";
import {
  get13DigitCodeForCartAmounts,
  get15DigitCodeForCartAmounts,
} from "~/features/addToCart/redux/cartAmounts/cartAmountsHelper";

/**
 * @deprecated use selectProperAmountInCart instead
 * Warning this can be productCode or productCode + packageCode
 * @param state
 * @param productCode
 * @param priceReference
 */
export function selectAmountInCart(state: RootState, productCode: string, priceReference: string) {
  const key = get13DigitCodeForCartAmounts(productCode, priceReference);
  return (state.cartAmounts && state.cartAmounts.cartQtyPerProductCode[key]) || 0;
}

export function selectIsCartEmpty(state: RootState) {
  return !Object.values(state.cartAmounts.cartQtyPerProductCode).some((amount) => !!amount);
}

export function selectIsCartAmountsIsLoading(state: RootState) {
  return state.cartAmounts.loading;
}

interface SelectProperAmountInCartProps {
  productCode: string;
  packCode: string;
  priceReference: string;
}
export function selectProperAmountInCart({ productCode, packCode, priceReference }: SelectProperAmountInCartProps) {
  return (state: RootState) => {
    if (!productCode) {
      return 0;
    }
    const productDescriptor = selectProductDescriptor(state, { productCode, priceReference });

    if (!productDescriptor) {
      return 0;
    }
    let key;
    if (productDescriptor.isMultiPrice) {
      key = get15DigitCodeForCartAmounts(productCode, packCode, priceReference);
    } else {
      key = get13DigitCodeForCartAmounts(productCode, priceReference);
    }
    return (state.cartAmounts && state.cartAmounts.cartQtyPerProductCode[key]) || 0;
  };
}
